import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthComponent } from './auth.component';
import { LogoutComponent } from './logout.component';
import { NoAuthGuard } from './no-auth-guard.service';
import { SharedModule, AuthGuard } from '../shared';
import { RecoveryComponent } from './recovery.component';
import { ChangePasswordComponent } from './changepassword.component';

const authRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'login',
    component: AuthComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'register',
    component: AuthComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account/recovery',
    component: RecoveryComponent,
   // canActivate: [NoAuthGuard]
  },
   {
    path: 'ResetPassword',
    component: ChangePasswordComponent,
    //canActivate: [NoAuthGuard]
  }
]);

@NgModule({
  imports: [
    authRouting,
    SharedModule
  ],
  declarations: [
    AuthComponent,
    RecoveryComponent,
    ChangePasswordComponent,
    LogoutComponent
  ],

  providers: [
    NoAuthGuard
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts